import React, { useEffect } from "react";
import { Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import usePayment from "../../Logic/usePayment";
import PlansCardStack from "../PlansCardStack";
import Style from "./ProjectPlans.module.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Icon from "../Layouts/Icons";
import CommonModal from "../Modals/CommonModal";
import { useSelector } from "react-redux";
import PaymentAddress from "../Modals/PaymentAddress";

const ProjectPlans = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { projectID, clientID } = useParams();
  const {isOpen } = useSelector((state) => state.payment);

  const {
    getClientPlans,
    getStudioPlans,
    allPlans,
    selectPlan,
    isSuccess,
    isItValidRequest,
    closePaymentModal,
  } = usePayment();

  useEffect(() => {
    /********************************************************************
     * isItValidRequest() CHECKS THE USER COMES THIS PAGE IS VALID OR NOT *
     *           IF IT NOT VALID USER WILL BE REDIRECT INTO DASHBOARD   *
     ********************************************************************/
    //isItValidRequest();

    if (projectID != undefined) {
      getClientPlans();
    } else {
      getStudioPlans();
    }

    if (
      location.pathname.startsWith("/dashboard") &&
      location.pathname !== "/user-plans"
    ) {
      document.body.setAttribute(
        "data-theme",
        localStorage.getItem("photofindtheme")
      );
    } else {
      document.body.setAttribute("data-theme", "default");
    }
    if (location.pathname === "/user-plans") {
    }
  }, []);

  const handleClick = () => {
    navigate(-1);
  };

  // const Tips = ({ id, children, title }) => (
  //   <OverlayTrigger placement="bottom" overlay={<Tooltip id={id}>{title}</Tooltip>}>
  //     <a href="#" >{children}</a>
  //   </OverlayTrigger>
  // );

  return (
    <div className={Style.ProjectPlans}>
      <Container>
        <div className={`section-title-block center`}>
          <h2>Click to create an account in FPA for your client.</h2>
          <p
            className={`${Style.whyTitle} d-flex justify-content-center align-items-center`}
          >
            why this plans?
            <span
              class="tooltipy fader"
              data-title="Cascading Stylesheets"
              data-tooltip="To enjoy all of the advantages of the Family Photos Album for your client"
            >
              <Icon color={"currentColor"} size={16} icon={"info-icon"} />
            </span>
            {/* <Tips id={1} title={"To enjoy all of the advantages of the Family Photos Album for your client"}> */}
            {/* </Tips> */}
            <button
              className="default btn btn-link link-primary btn-sm link-underline"
              onClick={() => handleClick()}
            >
              Skip
            </button>
          </p>
        </div>

        <PlansCardStack
          plansData={allPlans}
          buttonText={"Buy Now"}
          cardType={"client"}
          buttonCallback={selectPlan}
        />
        {/* <div className={Style.skipPlans}>
          <button onClick={() => handleClick()}>Skip</button>
        </div> */}
      <CommonModal
        showModal={isOpen}
        setShowModal={closePaymentModal}
        className={Style.payment_modal}
        content={<PaymentAddress/>}
      />
      </Container>
    </div>
  );
};

export default ProjectPlans;
